import { decode as _decodeHtml } from "html-entities";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _tcLib from "../lib/timecode.js";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import _xmlFormat from "xml-formatter";
const xmlFormat = _xmlFormat;
const ttmlFunc = _ttmlFunc;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const XMLParser = _XMLParser;
const tcLib = _tcLib;
const convertToPlainText = _convertToPlainText;
const decodeHtml = _decodeHtml;
export default {
  decode: function (input, options) {
    let events = [],
      displays = [],
      regions = {},
      paragraphs = [],
      timeBase = "media",
      useClockTime = false,
      defaultRegion,
      defaultStyle;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let fileJson = xmlToJson.parse(input);
    //if the fileJson is missing the tt element we need to add it in
    if (!fileJson.tt) {
      fileJson = {
        tt: fileJson
      };
    }
    timeBase = ttmlFunc.getTimeBaseValue(input) || "media";
    useClockTime = timeBase === "media" || timeBase === "clock" ? true : false;

    //console.log(JSON.stringify(fileJson, null, 4));
    try {
      if (fileJson.tt.head.layout && fileJson.tt.head.layout.region) {
        //Make sure regions is an array
        if (!Array.isArray(fileJson.tt.head.layout.region)) {
          fileJson.tt.head.layout.region = [fileJson.tt.head.layout.region];
        }
        fileJson.tt.head.layout.region.forEach(region => {
          regions[region['@_xml:id']] = region;
        });
      }
    } catch (err) {
      console.log("Unable to decode region data");
    }
    if (Array.isArray(fileJson.tt.body.div)) {
      fileJson.tt.body.div.forEach(paragraphGroup => {
        if (Array.isArray(paragraphGroup.p)) {
          paragraphGroup.p.forEach(paragraph => {
            paragraphs.push(paragraph);
          });
        } else {
          paragraphs.push(paragraphGroup.p);
        }
      });
    } else {
      if (fileJson.tt.body.div['@_region']) {
        defaultRegion = regions[fileJson.tt.body.div['@_region']];
      }
      if (fileJson.tt.body.div['@_style']) {
        defaultStyle = regions[fileJson.tt.body.div['@_style']];
      }
      if (Array.isArray(fileJson.tt.body.div.p)) {
        fileJson.tt.body.div.p.forEach(paragraph => {
          paragraphs.push(paragraph);
        });
      } else {
        paragraphs.push(fileJson.tt.body.div.p);
      }
    }
    paragraphs.forEach(paragraph => {
      if (!paragraph["#text"]) {
        return;
      }
      let ccDisplay = new ttmlFunc.singleLine.Display();
      let start = tcLib.parseTcToSec(paragraph["@_begin"], options.frameRate, options.dropFrame, useClockTime);
      let end = tcLib.parseTcToSec(paragraph["@_end"], options.frameRate, options.dropFrame, useClockTime);
      //console.log(start,end);

      paragraph["#text"] = paragraph["#text"].toString();
      let original = decodeHtml(paragraph["#text"]);
      //console.log("------")
      //console.log("Original:",original);
      let text = convertToPlainText(original);
      //console.log("Text:",text);
      let html = ttmlFunc.multiLine.formatText(original);
      //console.log("html:",html);
      let originX,
        originY,
        extentX,
        extentY,
        region = defaultRegion;
      if (paragraph["@_region"] && regions) {
        region = regions[paragraph["@_region"]];
      }
      if (paragraph["@_tts:origin"]) {
        originX = parseFloat(paragraph["@_tts:origin"].split(" ")[0].replace("%", ""));
        originY = parseFloat(paragraph["@_tts:origin"].split(" ")[1].replace("%", ""));
      } else if (region && region["@_tts:origin"]) {
        originX = parseFloat(region["@_tts:origin"].split(" ")[0].replace("%", ""));
        originY = parseFloat(region["@_tts:origin"].split(" ")[1].replace("%", ""));
      }
      if (paragraph["@_tts:extent"]) {
        extentX = parseFloat(paragraph["@_tts:extent"].split(" ")[0].replace("%", ""));
        extentY = parseFloat(paragraph["@_tts:extent"].split(" ")[1].replace("%", ""));
      } else if (region && region["@_tts:extent"]) {
        extentX = parseFloat(region["@_tts:extent"].split(" ")[0].replace("%", ""));
        extentY = parseFloat(region["@_tts:extent"].split(" ")[1].replace("%", ""));
      }
      if (displays.length > 0 && displays[displays.length - 1].start === start) {
        displays[displays.length - 1].insertLine({
          text: text,
          html: html,
          original: original,
          extentX: extentX,
          extentY: extentY,
          originX: originX,
          originY: originY,
          region: region
        });
      } else {
        ccDisplay.start = start;
        ccDisplay.end = end;
        ccDisplay.insertLine({
          text: text,
          html: html,
          original: original,
          extentX: extentX,
          extentY: extentY,
          originX: originX,
          originY: originY,
          region: region
        });
        displays.push(ccDisplay);
      }
    });

    //console.log(JSON.stringify(displays, null, 4));
    displays.forEach(display => {
      events.push(ttmlFunc.singleLine.decodeDisplay(display, options.window));
    });

    // console.log(JSON.stringify(events, null, 4));
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];
    let timeBase = encodingOptions["Time Base"] || "media";
    let tcFormat = encodingOptions["Timecode Format"] || "smpte";
    let output = eol.after(`<?xml version="1.0" encoding="UTF-8"?>`);
    output += eol.after(`<tt xmlns="http://www.w3.org/ns/ttml" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" xmlns:smpte="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt"  ttp:profile="http://www.w3.org/ns/ttml/profile/imsc1/text" xml:lang="${encodingOptions["Language Code"] || "en"}" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate]}" ttp:dropMode="${options.dropFrame ? "dropNTSC" : 'nonDrop'}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:timeBase="${timeBase}">`);
    output += eol.after(`   <head>`);
    output += eol.after(`       <metadata>
            <ttm:desc>CC Converter v3.5.17 - YouTube TTML Export</ttm:desc>
            <smpte:information xmlns:m608="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608" origin="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608" mode="Preserved" m608:channel="CC1" m608:programName="Untitled" m608:captionService="F1C1CC"/>
        </metadata>`);
    output += eol.after(`       <styling><style xml:id="basic" tts:color="${encodingOptions["Font Color"] || "white"}" tts:backgroundColor="${encodingOptions["Background Color"] || "black"}" tts:fontFamily="${encodingOptions["Font Family"] || "monospace"}" tts:fontWeight="${encodingOptions["Font Weight"] || "normal"}" tts:fontStyle="${encodingOptions["Font Style"] || "normal"}"/></styling>`);
    output += eol.after(`       <layout>
            <region xml:id='pop1' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='pop2' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='pop3' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='pop4' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='paint' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='paint2' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='paint3' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='paint4' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='rollup2' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='rollup3' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
            <region xml:id='rollup4' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        </layout>`);
    output += eol.after(`   </head>`);
    output += eol.after(`   <body>`);
    output += eol.after(`       <div>`);

    /* EVENTS */
    eventGroup.events.forEach(event => {
      let start, end;
      if (timeBase === "clock" || timeBase === "media") {
        start = tcFormat.toLowerCase() === "smpte" ? tcLib.formatTimecodeString(event.startSmpteClock, options.dropFrame) : event.startMsIncode;
        end = tcFormat.toLowerCase() === "smpte" ? tcLib.formatTimecodeString(event.endSmpteClock, options.dropFrame) : event.endMsIncode;
      } else {
        start = tcFormat.toLowerCase() === "smpte" ? tcLib.formatTimecodeString(event.startSmpte, options.dropFrame) : event.startMsIncode;
        end = tcFormat.toLowerCase() === "smpte" ? tcLib.formatTimecodeString(event.endSmpte, options.dropFrame) : event.endMsIncode;
      }

      //console.log(event.text);
      let plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true);
      eol.split(plainTextCustom).forEach((textLine, index, textLines) => {
        let extents = ttmlFunc.singleLine.calcExtents(textLine, options.window, 80);
        let origins = ttmlFunc.singleLine.calcOrigin(event, textLine, index, textLines.length, 80, options.window);
        output += `         <p region='pop${index + 1}' style='basic' begin='${start}' end='${end}' tts:origin='${origins}' tts:extent='${extents}'>${ttmlFunc.singleLine.convertToTtml(textLine)}</p>
`;
      });
    });
    output += eol.after(`       </div>`);
    output += eol.after(`   </body>`);
    output += `</tt>`;
    return eol.auto(output);
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input);
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};